import * as React from "react";

function SvgSort(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 18 24"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M18.01 8.72a1 1 0 01-.34.77 1.07 1.07 0 01-.79.33H1.12a1.09 1.09 0 01-.79-.33 1.05 1.05 0 010-1.48L8.21.32a1.1 1.1 0 01.8-.31 1.12 1.12 0 01.79.32l7.86 7.68a1 1 0 01.35.71zm-.34 5.78a1 1 0 01.34.77 1 1 0 01-.34.77l-7.88 7.63a1.09 1.09 0 01-.78.34 1.07 1.07 0 01-.79-.33L.33 16.01a1 1 0 01-.32-.74 1.06 1.06 0 01.33-.77 1.12 1.12 0 01.79-.32h15.74a1.1 1.1 0 01.79.32z" />
    </svg>
  );
}

const MemoSvgSort = React.memo(SvgSort);
export default MemoSvgSort;
